/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';
import store from '../store';

const getInstallationData = () => {
  return {
    installation_identifier:
      window.installationConfig?.installationIdentifier ||
      store.state.globalConfig.installationIdentifier,
    installation_version:
      window.installationConfig?.version || store.state.globalConfig.version,
    installation_host: window.location.hostname,
    installation_env: process.env.NODE_ENV,
    edition:
      window.installationConfig?.edition || store.state.globalConfig.edition,
    account_id: store.state.auth.currentUser?.account_id,
    user_id: store.state.auth.currentUser?.id,
    user_role: store.state.auth.currentUser?.role,
  };
};

const sendTelemetry = async (eventName, eventData = {}) => {
  try {
    const baseUrl = 'https://api.os.stacklab.digital/api';
    const eventsUrl = `${baseUrl}/events`;
    const installationData = getInstallationData();

    const info = {
      event_name: `funnel_${eventName}`,
      event_data: {
        ...eventData,
        ...installationData,
        component: 'FunnelAPI',
        timestamp: new Date().toISOString(),
      },
    };

    await fetch(eventsUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(info),
    });
  } catch (error) {
    // Silently fail to not disrupt user experience
    console.error('Telemetry error:', error);
  }
};

class FunnelAPI extends CacheEnabledApiClient {
  constructor() {
    super('funnels', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'funnel';
  }

  async create(data) {
    const response = await axios.post(this.url, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    await sendTelemetry('created', { funnel_id: response.data.id });
    return response;
  }

  async delete(id) {
    const response = await axios.delete(`${this.url}/${id}`);
    await sendTelemetry('deleted', { funnel_id: id });
    return response;
  }

  async update(id, data) {
    const response = await axios.patch(`${this.url}/${id}`, data, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    await sendTelemetry('updated', {
      funnel_id: id,
      changes: Object.keys(data),
    });
    return response;
  }

  async reorderStages(id, stages) {
    const response = await axios.patch(
      `${this.url}/${id}/reorder`,
      { stages },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
    await sendTelemetry('stages_reordered', {
      funnel_id: id,
      stages_count: stages.length,
    });
    return response;
  }
}

export default new FunnelAPI();
